import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Button,
  Input,
  Textarea,
} from '@heroui/react';
import React, { useState } from 'react';
import { CreateCustomBoardRequest } from '../../types/orderBoard';

interface CreateCustomBoardModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (request: CreateCustomBoardRequest) => Promise<void>;
}

const CreateCustomBoardModal: React.FC<CreateCustomBoardModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (!title.trim()) {
      return;
    }

    setIsSubmitting(true);
    try {
      await onConfirm({
        title: title.trim(),
        description: description.trim() || undefined,
      });
      handleClose();
    } catch (error) {
      // Error handling is done by parent
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setTitle('');
    setDescription('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size='md'>
      <ModalContent>
        <ModalHeader>Create Custom Board</ModalHeader>
        <ModalBody>
          <div className='space-y-4'>
            <Input
              label='Board Title'
              placeholder='Enter board title'
              value={title}
              onChange={e => setTitle(e.target.value)}
              isRequired
              autoFocus
            />

            <Textarea
              label='Description'
              placeholder='Optional description for this board'
              value={description}
              onChange={e => setDescription(e.target.value)}
              rows={3}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button variant='ghost' onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            color='primary'
            onClick={handleConfirm}
            disabled={!title.trim() || isSubmitting}
            isLoading={isSubmitting}
          >
            Create Board
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CreateCustomBoardModal;
